import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import _ from 'underscore';
import BreadCrumbs from './BreadCrumbs';

import config from './../config';

class SyslurListView extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/greinar/';

		this.state = {}
	}

	componentDidMount() {
		this.fetchData();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.match.params.id != this.props.match.params.id) {
			this.fetchData();
		}
	}

	fetchData() {
		fetch(this.url+(this.props.match.params.id ? '?collection='+this.props.match.params.id : ''))
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					data: (json.results)
				});
			}.bind(this));
	}

	render() {
		return (
			<div className={'row boxes'}>

				<div className={'col col-12'}>
					{
						this.state.data &&
						<div className="column-content">
							{
								this.state.sysla &&
								<BreadCrumbs path={[
									{
										path: '/greinar/',
										title: 'Greinar'
									}
								]} />
							}

							<h3>Greinar</h3>

							<hr/>

							<table className="table table-responsive">
								<thead>
									<tr>
										<th>Titill</th>
									</tr>
								</thead>
								<tbody>
									{
										this.state.data.map((item, index) => <tr key={index}>
											<td><Link to={'/grein/'+item.id}>{item.title}</Link></td>
										</tr>)
									}
								</tbody>
							</table>

						</div>
					}

				</div>

			</div>
		);
	}
}

export default withRouter(SyslurListView);



// WEBPACK FOOTER //
// ./src/components/GreinarListView.js